export function groupsJson (language) {
  let items

  if (language === 'es') {
    items = {
      newGroup: {
        name: 'newGroup',
        label: 'crear un grupo'
      },
      exportPdfGroups: {
        name: 'exportPdfGroups',
        label: 'exportar grupos en formato pdf'
      },
      exportCsvGroups: {
        name: 'exportCsvGroups',
        label: 'exportar grupos en formato csv'
      },
      removeGroups: {
        name: 'removeGroups',
        label: 'eliminar grupos'
      },
      seeDashboardGroup: {
        name: 'seeDashboardGroup',
        label: 'acceder al dashboard de los grupos'
      }
    }
  } else if (language === 'en') {
    items = {
      newGroup: {
        name: 'newGroup',
        label: 'create a group'
      },
      exportPdfGroups: {
        name: 'exportPdfGroups',
        label: 'export groups in PDF format'
      },
      exportCsvGroups: {
        name: 'exportCsvGroups',
        label: 'export groups in CSV format'
      },
      removeGroups: {
        name: 'removeGroups',
        label: 'delete groups'
      },
      seeDashboardGroup: {
        name: 'seeDashboardGroup',
        label: 'access the group dashboard'
      }
    }
  }

  return (items)
}
